var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    [
      _c("span", { class: ["event", _vm.eventStatusClass] }),
      _vm._v(" "),
      _c("router-link", { attrs: { to: _vm.eventRouterLink } }, [
        _vm._v(_vm._s(_vm.eventDescription)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }